module.exports = __webpack_public_path__ + "img/AssayFinder.064237e1.webp";